export enum EventLogType {
  LOG = 'LOG',
  EVENT = 'EVENT',
}

export enum Level {
  ERROR = 'ERROR',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
}

type BaseEventLog = {
  type: EventLogType
  customer_session?: string | null
  checkout_session?: string | null
  original_created_at: string
  metadata?: object | Array<object> | null
  url?: string | null
  os?: string | null
  sdk_version: string
  headers?: null | object & {
    user_agent?: string | null
    accept_language?: string | null
    sdk_type?: string
    workflow?: string
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'x-version'?: string
    platform?: string | null
  }
  application_session: string
  application_name: string
  environment: string
  public_api_key: string
  organization_name?: string | null
  client_app_name?: string | null
  client_app_domain?: string | null
  device_id?: string
}

export type Log = BaseEventLog & {
  method?: string | null
  request?: object | null
  response?: object | null
  status_code?: string | null
  trace_id?: string | null
  country?: string | null
  stack_trace?: string
  error_origin?: string
  level: Level
  step_name: string
  step_function: string
  step_location: string
  step_line?: number
}

export type Event = BaseEventLog & {
  source: string
  event: string
  entity_code?: string
  user_email?: string
  description: string
  params?: object
  location_lat?: number | null
  location_lng?: number | null
  location_info?: string | null
  device_id?: string | null
}

export type Metric = {
  environment: string
  dynamic_sdk: boolean
  original_created_at: string
  original_created_at_ms: number
  device_id?: string
  flow_trace_id: string
  checkout_session?: string | null
  customer_session?: string | null
  metadata: {
    country?: string
    public_api_key: string
    language?: string
  }
  sdk_version: string
  type: string
  payload: object
}

export type Batch = Log | Event | Metric
